export var version = "3.9.0";
//# sourceMappingURL=version.js.map